
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.494 14.36l-2.001-1.156v1.603H5.313v1.242h10.18v1.781l4.006-2.313-2.005-1.156z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M10.748 13.329V8.463l-2.556-.466c.685-.616 1.127-1.57 1.127-2.639C9.319 3.507 7.998 2 6.374 2 4.75 2 3.429 3.507 3.429 5.358c0 1.058.431 2.002 1.103 2.619L2 8.469v12.823h8.748v-3.89H9.505v2.648H3.243V9.493l3.014-.586 3.248.593v3.829h1.243zM6.374 3.242c.939 0 1.702.949 1.702 2.115 0 1.167-.764 2.116-1.702 2.116-.939 0-1.702-.949-1.702-2.116 0-1.166.763-2.115 1.702-2.115z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M19.458 7.985c.678-.616 1.113-1.564 1.113-2.627C20.57 3.507 19.25 2 17.626 2c-1.624 0-2.945 1.507-2.945 3.358 0 1.065.438 2.015 1.118 2.631l-2.547.477v4.863h1.243V9.497l3.155-.59 3.108.589V20.05h-6.263v-2.648h-1.243v3.89H22V8.467l-2.542-.482zm-1.832-4.742c.939 0 1.702.949 1.702 2.115 0 1.167-.763 2.116-1.702 2.116-.938 0-1.702-.949-1.702-2.116 0-1.166.764-2.115 1.702-2.115z","fill":"currentColor"}})])
          )
        }
      }
    